import React, { useCallback, useMemo, useReducer } from 'react';
import DV                                          from 'ts-data-validator';

import whereBuyConstants    from './whereBuy.constants';
import WhereBuyContext      from './whereBuy.context';
import whereBuyReducer      from './whereBuy.reducer';
import whereBuyInitialState from './whereBuy.state';

import useRequest from '../../common/services/request';

/**
 * @type {React.FC}
 */

function WhereBuyProvider({
  children,
  value,
}) {
  const [state, dispatch] = useReducer(whereBuyReducer, {
    ...whereBuyInitialState,
    cities:             value.cities || whereBuyInitialState.cities,
    initialStateLoaded: DV.isNotEmptyArray(value.items),
    items:              value.items || whereBuyInitialState.items,
    filter:             Array.isArray(value.filter) ? value.filter || whereBuyInitialState.filter : whereBuyInitialState.filter,
    regionData:         !DV.isUndefined(value.regionData) ? {
      title:           value.regionData.title || whereBuyInitialState.regionData.title,
      description:     value.regionData.description || whereBuyInitialState.regionData.description,
      metaTitle:       value.regionData.metaTitle || whereBuyInitialState.regionData.metaTitle,
      metaKeywords:    value.regionData.metaKeywords || whereBuyInitialState.regionData.metaKeywords,
      metaDescription: value.regionData.metaDescription || whereBuyInitialState.regionData.metaDescription,
      lat:             value.regionData.lat || whereBuyInitialState.regionData.lat,
      lng:             value.regionData.lng || whereBuyInitialState.regionData.lng,
      mapZoom:         value.regionData.mapZoom || whereBuyInitialState.regionData.mapZoom,
    } : { ...whereBuyInitialState.regionData },
    regions:            value.regions || whereBuyInitialState.regions,
    types:              value.types || whereBuyInitialState.types,
  });
  const { get }           = useRequest();

  const filterTradeStore = useCallback((typeTradeStore) => dispatch({
    type: whereBuyConstants.TRADE_STORE_FILTER_BY_TYPE,
    typeTradeStore,
  }));

  const getInitialState = useCallback((place) => {
    dispatch({ type: whereBuyConstants.TRADE_STORE_GET_INITIAL_STATE_REQUEST });

    const url = `/api/gde-kupit-kontakty${DV.isString(place) ? `/${place}` : ''}`;

    return get(url)
      .then((response) => dispatch({ type: whereBuyConstants.TRADE_STORE_GET_INITIAL_STATE_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: whereBuyConstants.TRADE_STORE_GET_INITIAL_STATE_FAILURE, ...error }));
  }, [dispatch]);

  React.useEffect(() => {
    getInitialState();
  }, []);

  const context = useMemo(() => ({
    ...state,
    filterTradeStore,
    getInitialState,
  }), [filterTradeStore, getInitialState, state]);

  return (
    <WhereBuyContext.Provider value={context}>
      {children}
    </WhereBuyContext.Provider>
  );
}

export default WhereBuyProvider;